var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "aria-current": "location",
      "active": "",
      "text": _vm.displayText('partner.partner_area', '合作夥伴專區')
    }
  }), _vm.isFromParnerPage ? _c('b-breadcrumb-item', {
    attrs: {
      "aria-current": "location",
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.partner_management", "合作夥伴管理")) + " ")]) : _vm._e(), _vm.isVerifyPage ? _c('b-breadcrumb-item', {
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v(_vm._s(_vm.displayText("partner.partner_worker_verify_page", "夥伴員工審核")) + " ")]) : _c('b-breadcrumb-item', {
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v(_vm._s(_vm.displayText("partner.partner_worker_management", "夥伴員工管理")) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? _vm.displayText("partner.worker_view", "查看夥伴員工") : _vm.isEditing ? _vm.displayText("partner.worker_edit", "編輯夥伴員工") : _vm.displayText("partner.worker_add", "新增夥伴員工")) + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? _vm.displayText("partner.worker_view", "查看夥伴員工") : _vm.isEditing ? _vm.displayText("partner.worker_edit", "編輯夥伴員工") : _vm.displayText("partner.worker_add", "新增夥伴員工")) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _vm.hiddenField('avatar') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.avatar', '個人頭像')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.avatar_url,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "avatar_url", $$v);
      },
      expression: "partnerWorker.avatar_url"
    }
  })], 1) : _vm._e(), _vm.hiddenField('employee_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": '*' + _vm.displayText('partner.worker_code', '員工編號')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.partnerWorker.employee_code.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.employee_code,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "employee_code", $$v);
      },
      expression: "partnerWorker.employee_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partnerWorker.employee_code.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": '*' + _vm.displayText('partner.worker_name', '員工姓名')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.partnerWorker.name.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.name,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "name", $$v);
      },
      expression: "partnerWorker.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partnerWorker.name.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.is_required", "此欄位為必填")) + " ")])], 1), _vm.hiddenField('email') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.email', 'Email')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.email,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "email", $$v);
      },
      expression: "partnerWorker.email"
    }
  })], 1) : _vm._e(), _vm.hiddenField('mobile_phone') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.mobile', '手機')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.mobile_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "mobile_phone", $$v);
      },
      expression: "partnerWorker.mobile_phone"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": (_vm.requiredStaff() ? '*' : '') + _vm.displayText('partner.worker_sales', '業務員')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.partnerWorker.staff ? _c('b-form-text', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_vm._v(" " + _vm._s(_vm.partnerWorker.staff.name) + " ")]) : _vm._e(), !_vm.isReadOnly ? _c('b-button', {
    staticClass: "mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.showPartnerWorkerAddStaff = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.displayText("partner.select_sales", "選擇業務員")) + " ")]) : _vm._e()], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partnerWorker.staff_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.is_required", "此欄位為必填")) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": '*' + _vm.displayText('partner.title', '合作夥伴')
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.partners,
      "disabled": _vm.isPartnerIdDisabled
    },
    on: {
      "input": _vm.setPartnerId
    },
    model: {
      value: _vm.selectedPartner,
      callback: function callback($$v) {
        _vm.selectedPartner = $$v;
      },
      expression: "selectedPartner"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.partnerWorker.partner_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("partner.is_required", "此欄位為必填")) + " ")])], 1), _vm.hiddenField('job_specialty') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_job_specialty_name', '服務科室')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.job_specialty,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "job_specialty", $$v);
      },
      expression: "partnerWorker.job_specialty"
    }
  })], 1) : _vm._e(), _vm.hiddenField('job_type') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_job_type', '職位類型')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.job_type,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "job_type", $$v);
      },
      expression: "partnerWorker.job_type"
    }
  })], 1) : _vm._e(), _vm.hiddenField('job_title') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_job_title', '職稱')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.job_title,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "job_title", $$v);
      },
      expression: "partnerWorker.job_title"
    }
  })], 1) : _vm._e(), _vm.hiddenField('priority') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_priority', '重點客戶')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "options": _vm.priorityOptions,
      "readonly": _vm.isReadOnly,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.priority,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "priority", $$v);
      },
      expression: "partnerWorker.priority"
    }
  })], 1) : _vm._e(), _vm.hiddenField('category') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_category', '客戶分類')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "options": _vm.categoryOptions,
      "readonly": _vm.isReadOnly,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.category,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "category", $$v);
      },
      expression: "partnerWorker.category"
    }
  })], 1) : _vm._e(), _vm.hiddenField('line_uid') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.line_uid', 'LINE UID')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.line_id,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "line_id", $$v);
      },
      expression: "partnerWorker.line_id"
    }
  })], 1) : _vm._e(), _vm.hiddenField('dept_name') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_dept_name', '部門名稱')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.dept_name,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "dept_name", $$v);
      },
      expression: "partnerWorker.dept_name"
    }
  })], 1) : _vm._e(), _vm.hiddenField('created_at') && (_vm.isReadOnly || _vm.isEditing) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.created_at', '建立時間')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.partnerWorker.created_at,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "created_at", $$v);
      },
      expression: "partnerWorker.created_at"
    }
  })], 1) : _vm._e(), _vm.hiddenField('enabled_at') && (_vm.isReadOnly || _vm.isEditing) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.enabled_at', '接觸時間')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.partnerWorker.enabled_at,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "enabled_at", $$v);
      },
      expression: "partnerWorker.enabled_at"
    }
  })], 1) : _vm._e(), _vm.hiddenField('status_at') && (_vm.isReadOnly || _vm.isEditing) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.status_at', '驗證時間')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.partnerWorker.status_at,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "status_at", $$v);
      },
      expression: "partnerWorker.status_at"
    }
  })], 1) : _vm._e(), _vm.hiddenField('data_source') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.worker_data_source', '資料來源')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "options": _vm.dataSourceOptions,
      "readonly": _vm.isReadOnly,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.data_source,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "data_source", $$v);
      },
      expression: "partnerWorker.data_source"
    }
  })], 1) : _vm._e(), _vm.hiddenField('is_enabled') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.is_enabled', '是否啟用')
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.partnerWorker.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "is_enabled", $$v);
      },
      expression: "partnerWorker.is_enabled"
    }
  })], 1) : _vm._e(), _vm.hiddenField('status') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayText('partner.status', '狀態')
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.isReadOnly,
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.partnerWorker.status,
      callback: function callback($$v) {
        _vm.$set(_vm.partnerWorker, "status", $$v);
      },
      expression: "partnerWorker.status"
    }
  })], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)]), !_vm.isReadOnly ? _c('PartnerWorkerAddStaff', {
    attrs: {
      "show-add-staff": _vm.showPartnerWorkerAddStaff
    },
    on: {
      "selected": _vm.handleStaffSelected,
      "close": function close($event) {
        _vm.showPartnerWorkerAddStaff = false;
      }
    }
  }) : _vm._e()], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }